var React = require('react');

function Coffee (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25.5 10.5H27C28.6569 10.5 30 11.8431 30 13.5C30 15.1569 28.6569 16.5 27 16.5H25.5C25.4499 16.5 25.4002 16.4988 25.3507 16.4964C24.6572 19.9215 21.6297 22.5 18 22.5H15C10.8579 22.5 7.5 19.1421 7.5 15V10.5C7.5 8.84315 8.84315 7.5 10.5 7.5H22.5C24.1569 7.5 25.5 8.84315 25.5 10.5ZM30 25.5C30.8284 25.5 31.5 26.1716 31.5 27C31.5 27.8284 30.8284 28.5 30 28.5H6C5.17157 28.5 4.5 27.8284 4.5 27C4.5 26.1716 5.17157 25.5 6 25.5H30ZM10.5 15V10.5H22.5V15C22.5 17.4853 20.4853 19.5 18 19.5H15C12.5147 19.5 10.5 17.4853 10.5 15Z","fill":"#D33736"}));
}

Coffee.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Coffee;

Coffee.default = Coffee;
